var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMaintance = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 150,
  height: 150,
  viewBox: "0 0 22 21",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#757575"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 17.44a2 2 0 0 0 .6 1.46l1.5 1.5a2 2 0 0 0 1.46.6A2 2 0 0 0 5 20.4l5-4.89.79.8 1.42-1.42-2.34-2.29 1.23-1.23 4.38 4.38a3.48 3.48 0 0 0 3 5.25 3.4 3.4 0 0 0 1.16-.21L17 18.12 19.12 16l2.67 2.66A3.4 3.4 0 0 0 22 17.5a3.5 3.5 0 0 0-3.5-3.5 3.56 3.56 0 0 0-1.56.38L12.52 10l5.71-5.72h1.36L21 1.41 19.59 0l-2.83 1.41v1.42l-8.31 8.36L6.16 8.9l-1.41 1.41.79.79L.6 16a2 2 0 0 0-.6 1.44m7-4.93 1.57 1.58L3.51 19 2 17.4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.21 2.34A3.4 3.4 0 0 0 1 3.5a3.48 3.48 0 0 0 5.25 3L8.78 9l1.41-1.41-2.57-2.53A3.56 3.56 0 0 0 8 3.5 3.5 3.5 0 0 0 4.5 0a3.4 3.4 0 0 0-1.16.21L6 2.88 3.88 5Z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMaintance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/maintance.e10bcf9f3b3e0959da872aa3f516ce79.svg";